var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinIn = function SvgLinkedinIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.747 17.6H3.554V7.318h3.193zM5.15 5.916C4.13 5.916 3.3 5.07 3.3 4.049a1.849 1.849 0 0 1 3.698 0c0 1.02-.828 1.867-1.849 1.867M18.697 17.6H15.51v-5.005c0-1.193-.024-2.723-1.66-2.723-1.66 0-1.915 1.296-1.915 2.637v5.09H8.747V7.319h3.062v1.403h.045c.426-.808 1.467-1.66 3.02-1.66 3.232 0 3.826 2.127 3.826 4.89V17.6z"
  })));
};
export default SvgLinkedinIn;